var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDimensions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "282px",
    height: "278px",
    viewBox: "0 0 282 278",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filtros-B",
    transform: "translate(-1264, -75)",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1189, 34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(83.976, 47)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#333333",
    points: "83.3698059 97.5333333 127.600914 124.133333 171.832022 97.5333333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(82.4794, 221.6667)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 45.1215586,
    y1: -5.04011647e-13,
    x2: 45.1215586,
    y2: 35.4666667,
    id: "Path-3-Copy",
    stroke: "#333333",
    transform: "translate(45.1216, 17.7333) scale(1, -1) translate(-45.1216, -17.7333)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.173313081,
    y1: 15.4013544,
    x2: 45.0563643,
    y2: 43.6667428,
    id: "Path-3-Copy-2",
    stroke: "#FDBB31"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.1215586,
    y1: 17.7333333,
    x2: 89.3526668,
    y2: 44.3333333,
    id: "Path-2-Copy",
    stroke: "#0071CE",
    transform: "translate(67.2371, 31.0333) scale(1, -1) translate(-67.2371, -31.0333)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(127.6009, 22.1667) scale(1, -1) translate(-127.6009, -22.1667)translate(83.3698, 0)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,44.3333333 L43.2003697,18.3532058 C43.8346008,17.9717877 44.6276158,17.9717877 45.2618468,18.3532058 L88.4622165,44.3333333 L88.4622165,44.3333333",
    id: "Path-2-Copy",
    transform: "translate(44.2311, 31.0333) scale(1, -1) translate(-44.2311, -31.0333)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.2311083,
    y1: -5.04011647e-13,
    x2: 44.2311083,
    y2: 35.4666667,
    id: "Path-3-Copy",
    transform: "translate(44.2311, 17.7333) scale(1, -1) translate(-44.2311, -17.7333)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(28.6768, 195.0169) scale(-1, 1) translate(-28.6768, -195.0169)translate(0, 157.3327)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30.8524088,
    y1: 38.2672728,
    x2: 0.521641038,
    y2: 20.000589,
    id: "Path-3-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.66729927,48.0916583 L28.7811693,26.953526 C29.0944627,26.7766847 29.4786006,26.7817588 29.7871136,26.9668137 L66.0208381,48.7008295 L66.0208381,48.7008295",
    id: "Path-2-Copy-2",
    transform: "translate(28.6768, 37.6841) scale(1, -1) rotate(59) translate(-28.6768, -37.6841)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(28.6768, 70.9831) scale(-1, -1) translate(-28.6768, -70.9831)translate(0, 33.299)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.66729927,48.0916583 L28.7811693,26.953526 C29.0944627,26.7766847 29.4786006,26.7817588 29.7871136,26.9668137 L66.0208381,48.7008295 L66.0208381,48.7008295",
    id: "Path-2-Copy-2",
    transform: "translate(28.6768, 37.6841) scale(1, -1) rotate(59) translate(-28.6768, -37.6841)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.8524088,
    y1: 38.2672728,
    x2: 0.521641038,
    y2: 20.000589,
    id: "Path-3-Copy-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(235.3713, 70.9831) scale(1, -1) translate(-235.3713, -70.9831)translate(206.6945, 33.299)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30.8524088,
    y1: 38.2672728,
    x2: 0.521641038,
    y2: 20.000589,
    id: "Path-3-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.66729927,48.0916583 L28.7811693,26.953526 C29.0944627,26.7766847 29.4786006,26.7817588 29.7871136,26.9668137 L66.0208381,48.7008295 L66.0208381,48.7008295",
    id: "Path-2-Copy-2",
    transform: "translate(28.6768, 37.6841) scale(1, -1) rotate(59) translate(-28.6768, -37.6841)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(206.6945, 148.4661)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30.8524088,
    y1: 38.2672728,
    x2: 0.521641038,
    y2: 20.000589,
    id: "Path-3-Copy-2",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.66729927,48.0916583 L28.7811693,26.953526 C29.0944627,26.7766847 29.4786006,26.7817588 29.7871136,26.9668137 L66.0208381,48.7008295 L66.0208381,48.7008295",
    id: "Path-2-Copy-2",
    stroke: "#0071CE",
    transform: "translate(28.6768, 37.6841) scale(1, -1) rotate(59) translate(-28.6768, -37.6841)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 127.600914,
    y1: 124.133333,
    x2: 127.600914,
    y2: 177.333333,
    id: "Path-3",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.514026,
    y1: 66.1909001,
    x2: 245.514026,
    y2: 108.588983,
    id: "Path-3-Copy-2",
    stroke: "#45AB19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.514026,
    y1: 148.417485,
    x2: 245.514026,
    y2: 190.815567,
    id: "Path-3-Copy-2",
    stroke: "#45AB19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.5340241,
    y1: 199.8091,
    x2: 57.0052109,
    y2: 221.650536,
    id: "Path-3-Copy-2",
    stroke: "#FDBB31"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions);
export default __webpack_public_path__ + "static/media/dimensions.abf505db16c0e08fc3773c20a5cb88f0.svg";
export { ForwardRef as ReactComponent };